import 'font-awesome/css/font-awesome.min.css';
import "./assets/css/vendor/bootstrap.min.css";
import "./assets/css/vendor/bootstrap.rtl.only.min.css";
import "react-circular-progressbar/dist/styles.css";
import "react-perfect-scrollbar/dist/css/styles.css";
// import "react-big-calendar/lib/css/react-big-calendar.css";
import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import "./assets/css/App.css";

import { defaultColor, themeColorStorageKey, isDarkSwitchActive } from "./constants/defaultValues";

const color = (isDarkSwitchActive) && localStorage.getItem(themeColorStorageKey) ? localStorage.getItem(themeColorStorageKey) : defaultColor;
localStorage.setItem(themeColorStorageKey, color);

// console.log(window.location.pathname)

let render = () => {
    import('./assets/css/sass/themes/gogo.' + color + '.scss')
        .then(x => {
            require('./AppRenderer');
        });
};
render();